import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, effect, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDrawerMode } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";
import { MaterialModule } from "../../../material";
import { Navbar } from "../navbar/navbar";
import { SiteNav } from "../site-nav/site-nav";

@Component({
    selector: "app-main-layout",
    imports: [RouterOutlet, MaterialModule, Navbar, SiteNav],
    templateUrl: "./main-layout.html",
    styleUrl: "./main-layout.scss",
})
export class MainLayout {
    isDrawerOpen = signal<boolean>(true);
    drawerMode = signal<MatDrawerMode>("side");
    private breakpointObserver = inject(BreakpointObserver);

    constructor() {
        this.breakpointObserver
            .observe(["(max-width: 1000px)"])
            .pipe(takeUntilDestroyed())
            .subscribe((result) => {
                if (result.matches) {
                    this.isDrawerOpen.set(false);
                    this.drawerMode.set("over");
                } else {
                    this.isDrawerOpen.set(true);
                    this.drawerMode.set("side");
                }
            });

        effect(() => {
            if (this.isDrawerOpen() && this.drawerMode() === "side") {
                document.body.classList.add("drawer-open");
            } else {
                document.body.classList.remove("drawer-open");
            }
        });
    }

    toggleDrawer(): void {
        this.isDrawerOpen.update((curr) => !curr);
    }

    protected onNavItemClick(): void {
        if (this.drawerMode() === "over") {
            this.isDrawerOpen.set(false);
        }
    }

    protected onDrawerClosed(): void {
        this.isDrawerOpen.set(false);
    }
}
